interface String {
  getBaseUrl(): string;
}

String.prototype.getBaseUrl = function (this: string) {
  const urlObj = new URL(this)
  return urlObj.hostname;
}
